module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Light.ttf?aeae25fa83973ba1bbb96ca443ce709b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Light.ttf
// module id = 1393
// module chunks = 0